import { baseURL, request } from '@/common/appCtx';

import { HUGH_COUNT } from './const';

export const getStationDropdownList = (params = { count: HUGH_COUNT }) => {
  return request.get('/api/admin/station/dropdown/search/', { params });
};

export interface GetStationShiftListParams {
  // 0: disabled, 1: enabled
  status: 0 | 1;
  slot_code?: string;
  start_time?: string;
  end_time?: string;
  staff_type?: number;
  pageno: number;
  count: number;
}

export interface GetStationShiftListResponse {
  retcode?: number;
  message?: string;
  data?: {
    count?: number;
    total?: number;
    pageno?: number;
    list?: {
      id: number;
      slot_id: string;
      slot_code: string;
      start_time: string;
      end_time: string;
      staff_type: number;
      create_station_id: number;
      break_time: number;
      event_id_list?: string[];
    }[];
  };
}

export const getStationShiftList = (params: GetStationShiftListParams) => {
  return request.get<GetStationShiftListResponse>('/api/wfm/admin/roster_planning/slot/station_slot_list', { params });
};

export interface GetAdminShiftListParams {
  slot_code?: string;
  start_time?: string;
  end_time?: string;
  staff_type?: string;
  pageno: number;
  count: number;
}

export interface GetAdminShiftListResponse {
  retcode?: number;
  message?: string;
  data?: {
    total: number;
    pageno: number;
    count: number;
    list?: {
      id: number;
      slot_id: string;
      slot_code: string;
      start_time: string;
      end_time: string;
      staff_type: number;
      station?: {
        station_id: number;
        station_name: string;
      };
      create_station_id: number;
      break_time: number;
      can_delete: boolean;
    }[];
  };
}

export const getAdminShiftList = (params: GetAdminShiftListParams) => {
  return request.get<GetAdminShiftListResponse>('/api/wfm/admin/roster_planning/slot/admin_slot_list', { params });
};

export interface CreateShiftParams {
  slot_code?: string;
  start_time: string;
  end_time: string;
  station_id_list: number[];
  staff_type: number;
}

export const createShift = (params: CreateShiftParams) => {
  return request.post('/api/wfm/admin/roster_planning/slot/create', params, undefined, { shouldNotNotifyError: true });
};

export interface UpdateShiftParams {
  slot_id: string;
  slot_code?: string;
  start_time: string;
  end_time: string;
  station_id_list: number[];
  staff_type: number;
}

export const updateShift = (params: UpdateShiftParams) => {
  return request.post('/api/wfm/admin/roster_planning/slot/update', params, undefined, { shouldNotNotifyError: true });
};

export const deleteShift = (params: { slot_id: number; is_approve: 0 | 1 }) => {
  return request.post('/api/wfm/admin/roster_planning/slot/delete', params);
};

export const downloadTemplate = (params: { template_key: string }) => {
  window.open(`${baseURL}/api/wfm/common/download_template?template_key=${params.template_key}`);
};

export const batchCreate = (params: FormData) => {
  return request.post('/api/wfm/admin/roster_planning/slot/upload_create_slot', params);
};

export const downloadFailLog = (params: { fail_data: string }) => {
  return request.post('/api/wfm/admin/roster_planning/slot/download_upload_failed_slot', params, { responseType: 'blob' });
};

export const enableShift = (params: { slot_id_list: string[] }) => {
  return request.post('/api/wfm/admin/roster_planning/slot/station/enable', params);
};

export const disableShift = (params: { slot_id: string }) => {
  return request.post('/api/wfm/admin/roster_planning/slot/station/disable', params);
};

export interface GetLogListParams {
  station_id: number;
  pageno: number;
  count: number;
}

export interface GetLogListResponse {
  retcode: number;
  message: string;
  data: {
    total: number;
    pageno: number;
    count: number;
    list: {
      operation_time: number;
      slot_id: string;
      operation_event: string;
      operator: string;
      old_value: string;
      new_value: string;
    }[];
  };
}

export const getLogList = (params: GetLogListParams) => {
  return request.get<GetLogListResponse>('/api/wfm/admin/roster_planning/slot/log_list', { params });
};
